import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import StartPage from "./components/Page/StartPage";
import GamePage from "./components/Page/GamePage";
import DevPage from "./components/Page/DevPage";
import Footer from "./components/common/Footer";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<StartPage />} />
        <Route path="/game" element={<GamePage />} />
        <Route path="/dev" element={<DevPage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
